// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetDraggable/styles.scss
// module id = 859
// module chunks = 0